
import { Component, Vue } from "vue-property-decorator";
import { Bar } from "vue-chartjs/legacy";
import { dataVisualizationModule } from "@/store";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale
} from "chart.js";

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale);

@Component({
  components: {
    Bar
  }
})
export default class CurrentAgePercentageChart extends Vue {
  chartDatas = {
    labels: [] as string[],
    datasets: [] as any[]
  };

  chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false
      },
      tooltip: {
        callbacks: {
          label: function(context: any) {
            return `${context.dataset.label}: ${context.parsed.y.toFixed(1)} %`;
          }
        }
      }
    },
    scales: {
      y: {
        ticks: {
          precision: 0, // no decimals
          stepSize: 1,  // force step size of 1
          callback: function (value: number) {
            return Number.isInteger(value) ? value : '';
          }
        },
        beginAtZero: true
      }
    }
  };


  get rawChartData(): any[] {
    return dataVisualizationModule.getChartData("currentAgeCount");
  }

  get chartDataAvailable(): boolean {
    return (
        this.chartDatas.labels.length > 0 &&
        this.chartDatas.datasets.length > 0 &&
        this.chartDatas.datasets[0].data.length > 0
    );
  }

  async mounted() {
    try {
      await dataVisualizationModule.loadAll("currentAgeCount");

      const rawData = this.rawChartData;

      // ✅ Use second row for percentages
      if (Array.isArray(rawData) && rawData.length > 1 && rawData[1]) {
        const percentageRow = rawData[1];
        const labels = Object.keys(percentageRow);

        const data = Object.values(percentageRow).map(val => {
          if (typeof val === 'string' && val.includes('%')) {
            return parseFloat(val.replace('%', '').trim());
          }
          return 0;
        });

        this.chartDatas = {
          labels,
          datasets: [
            {
              label: "Patient Percentage",
              backgroundColor: [
                '#ffac1c', '#ff6f00', '#ffd700', '#ff8c00', '#ffa07a',
                '#ffc107', '#cd5c5c', '#ffb6c1', '#d2b48c', '#deb887'
              ],
              data
            }
          ]
        };
      }
    } catch (e) {
      console.error("Failed to load chart data", e);
    }
  }


}
